import React from "react";
import "../../styles/OurTeam.css";
import linkedInLogo from "../../images/linkedin-logo.svg";
import twitterLogo from "../../images/twitter.svg";

const styles = {
  socialLogo: {
    height: 40,
    width: 40,
    marginRight: 35,
    marginLeft: 35
  }
};

export default function Card(props) {
  return (
    <div className="card teamCardStyle">
      <img class="card-img-top" src={props.image} alt={props.name} />
      <div class="card-body">
        <h5 class="card-title">{props.name}</h5>
        <p class="card-text">{props.about}</p>
        <a href={props.linkedIn} target="_blank" rel="noopener noreferrer">
          <img style={styles.socialLogo} src={linkedInLogo} alt="linkedin" />
        </a>
        <a href={props.twitter} target="_blank" rel="noopener noreferrer">
          <img
            className="mt-1"
            style={styles.socialLogo}
            src={twitterLogo}
            alt="twitter"
          />
        </a>
      </div>
    </div>
  );
}
